import { Clock, ArrowUpRight } from "lucide-react";
import { resolveImage } from "@/lib/api";

export default function Courses({ data, onEnquire }) {
  const items = data?.items || [];
  return (
    <section id="courses" data-testid="section-courses" className="section-pad bg-white">
      <div className="container-pad">
        <div className="max-w-2xl">
          <div className="kicker">{data.kicker || "What We Offer"}</div>
          <h2 className="heading-main mt-4">{data.title}</h2>
          <p className="heading-sub">Industry-relevant programs designed to shape confident pharma & healthcare professionals.</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((c, i) => (
            <article
              key={i}
              className="card-elev overflow-hidden group fade-up"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`course-card-${i}`}
            >
              <div className="aspect-[5/3] overflow-hidden">
                <img
                  src={resolveImage(c.image)}
                  alt={c.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-700"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between gap-3">
                  <span className="pill"><Clock className="w-3 h-3" /> {c.duration || "Flexible"}</span>
                  <span className="text-xs font-semibold text-slate-400">0{i + 1}</span>
                </div>
                <h3 className="mt-4 text-lg md:text-xl font-bold text-[#0F172A] leading-snug">{c.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{c.description}</p>
                <button
                  onClick={onEnquire}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1E3A8A] hover:text-teal-700 transition"
                  data-testid={`course-enquire-${i}`}
                >
                  Enquire about this course <ArrowUpRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
